import React, { useCallback, useEffect } from 'react'
import Table from 'react-bootstrap/cjs/Table'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import styled from 'styled-components'
import Icon from 'components/Icon'
import { _ } from 'utils'
import {
    crewSelector, deleteCrew, fetchCrew, Slugs
} from './crewSlice'
import { Crew } from './types'
import { fetchBooth } from '../config/fetchBoothSlice'

const S = {
    Thumbnail: styled.img`
        height: 36px;
        width: 36px;
        border-radius: 36px;
    `,
    TextTd: styled.td`
        padding-top: 16px !important;
    `
}

const CrewRow = ({ crew }: { crew: Crew }) => {
    const params = useParams<Slugs>()
    const dispatch = useDispatch()
    const onDelete = useCallback(() => {
        dispatch(deleteCrew({ crew, ...params }))
    }, [crew, dispatch, params])
    return (
        <tr key={crew.id}>
            <td>
                <S.Thumbnail src={crew.mugshot} alt="" />
            </td>
            <S.TextTd>
                {`${crew.first_name} ${crew.last_name}`}
            </S.TextTd>
            <S.TextTd>
                {crew.email}
            </S.TextTd>
            <td>
                <Icon icon="trash" onClick={onDelete} />
            </td>
        </tr>
    )
}

const CrewOverview = () => {
    const params = useParams<Slugs>()
    const dispatch = useDispatch()
    const crewList = useSelector(crewSelector)

    useEffect(() => {
        dispatch(fetchCrew(params))
        dispatch(fetchBooth({ eventSlug: params.eventSlug, boothSlug: params.boothSlug }))
    }, [dispatch, params])

    if (crewList.length === 0) {
        return <h6>{_('booth.crew.list.empty_crew_list')}</h6>
    }

    return (
        <Table hover>
            <thead>
                <th className="border-0">{/* user thumbnail */}</th>
                <th className="border-0">{_('booth.crew.list.table_headers.name')}</th>
                <th className="border-0">Email</th>
                <th className="border-0">{/* actions */}</th>
            </thead>
            <tbody>
                {
                    crewList.map((crew: Crew) => (
                        <CrewRow crew={crew} key={crew.id} />
                    ))
                }
            </tbody>
        </Table>
    )
}

export default CrewOverview
